import BridgeController from "./bridge_controller";

export default class extends BridgeController {
  connect() {
    super.connect();
    this.handleUploadComplete = () => this.unmount();
    document.addEventListener("vetomatic:upload-complete", this.handleUploadComplete);
  }

  disconnect() {
    document.removeEventListener("vetomatic:upload-complete", this.handleUploadComplete);
  }
}
